import axios from 'axios';
import React, { Component } from "react";
// reactstrap components
// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  Modal,
  Button,
  Form,
  FormGroup,
  Input,
  Col,
  UncontrolledTooltip
} from "reactstrap";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";

// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
// connect
import connect from 'redux-connect-decorator';
import { getWords, deleteGlossary, saveOrUpdate } from '../../../../actions/glossaryActions';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { toast } from 'react-toastify';
import isEmpty from '../../../../utils/is-empty';

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={e => onSizePerPageChange(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  )
});

const { SearchBar } = Search;

const allUpperCase = (cell, row) => {
  return <span>{cell.toUpperCase()}</span>;
}

const allBold = (cell, row) => {
  return <b>{cell}</b>;
}

const allItalic = (cell, row) => {
  return <i>{cell}</i>;
}

@connect(
  state => ({
    words: state.word.words,
    loading: state.word.loading
  }),
  {
    getWords
  }
)
class Vocabulary extends Component<any, any> {
  state = {
    _id: null,
    selectedData: null,
    defaultModal: null,
    topic: null,
    english: null,
    vietnamese: null,
    usage: null,
    pronunciation: null
  }

  componentDidMount() {
    this.props.getWords();
  }

  constructor(props) {
    super(props);
  }

  resetState = () => {
    this.setState({
      _id: null,
      selectedData: null,
      defaultModal: null,
      topic: null,
      english: null,
      vietnamese: null,
      usage: null,
      pronunciation: null
    });
  }

  toggleModal = state => {
    this.setState({
      [state]: !this.state[state]
    });
  };

  onSave = async () => {
    console.log(`onSave`, this.state);
    if (isEmpty(this.state.topic) || isEmpty(this.state.english) || isEmpty(this.state.vietnamese)
      || isEmpty(this.state.pronunciation) || isEmpty(this.state.usage)) {
      toast.error('Nhập đủ thông tin trước khi tiếp tục');
      return;
    }
    let data = { ...this.state};

    const result = await saveOrUpdate(data);
    if (result && result.status == 200) {
      this.props.getWords();
      toast.success('Add or update word success.');
      this.toggleModal("defaultModal");
    }
  }

  addNew = () => {
    // reset
    this.resetState();
    // logic
    this.toggleModal("defaultModal");
  }

  edit = (e, row) => {
    e.preventDefault();
    // reset
    this.resetState();
    this.setState({
      ...row,
      selectedData: row
    });
    // logic
    this.toggleModal("defaultModal");
  }

  onDelete = async (row) => {
    const result = await deleteGlossary(row._id);
    // Load user again
    if (result && result.status == 200) {
      this.props.getWords();
      toast.success('Delete word success.');
    }
  }


  confirmDelete = (e, row) => {
    e.preventDefault();
    confirmAlert({
      title: 'Confirm to delete',
      message: `Are you sure to delete this word: ${row.english}`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.onDelete(row)
        },
        {
          label: 'No',
          onClick: null
        }
      ]
    });
  }

  addActionButton = (cell, row) => {
    return (
        <div className="table-actions">
            <a
              className="table-action table-action-play"
              href="#"
              id="tooltip123539273"
              onClick={e => this.edit(e, row)}
            >
              <i className="fas fa-edit" />
            </a>
            <UncontrolledTooltip delay={0} target="tooltip123539273">
              Edit
            </UncontrolledTooltip>
            <a
              className="table-action table-action-transcript"
              href="#"
              id="tooltip397466356"
              onClick={e => this.confirmDelete(e, row)}
            >
              <i className="fas fa-trash-alt" />
            </a>
            <UncontrolledTooltip delay={0} target="tooltip397466356">
              Delete
            </UncontrolledTooltip>
        </div>
    )
  }
  render() {
    const { words, loading } = this.props;
    return (
      <>
        <SimpleHeader name="Glossary" parentName="Management" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card>
                <CardHeader>
                  <Button 
                    className="btn btn-info btn-sm"
                    onClick={this.addNew}
                  >Add new</Button>
                  <p className="text-sm mb-0"></p>
                </CardHeader>
                { words && <ToolkitProvider
                  data={ words }
                  keyField="_id"
                  columns={[
                    {
                      dataField: "topic",
                      text: "Topic",
                      sort: true,
                      formatter: allUpperCase
                    },
                    {
                      dataField: "english",
                      text: "English",
                      sort: true,
                      formatter: allBold
                    },
                    {
                      dataField: "vietnamese",
                      text: "Vietnamese",
                      formatter: allItalic,
                      sort: true
                    },
                    {
                      dataField: "pronunciation",
                      text: "Pronunciation",
                      sort: false
                    },
                    {
                      dataField: "action",
                      text: "Action",
                      searchable: false,
                      sort: false,
                      formatter: this.addActionButton
                    }
                  ]}
                  search
                >
                  {props => (
                    <div className="py-4 table-responsive align-items-center table-flush table">
                      <div
                        id="datatable-basic_filter"
                        className="dataTables_filter px-4 pb-1"
                      >
                        <label>
                          Search:
                          <SearchBar
                            className="form-control-sm"
                            placeholder=""
                            {...props.searchProps}
                          />
                        </label>
                      </div>
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4={true}
                        pagination={pagination}
                        bordered={false}
                      />
                    </div>
                  )}
                </ToolkitProvider>
                }
              </Card>
            </div>
          </Row>

          <Modal
              className="modal-dialog-centered modal-lg"
              isOpen={this.state.defaultModal}
              toggle={() => this.toggleModal("defaultModal")}
            >
              <div className="modal-header">
                <h6 className="modal-title" id="modal-title-default">
                  <div>Top student : { this.state.selectedData ? 'Edit' : 'New'}</div>
                  <small></small>
                </h6>
                <button
                  aria-label="Close"
                  className="close"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => this.toggleModal("defaultModal")}
                >
                  <span aria-hidden={true}>×</span>
                </button>
              </div>
              <div className="modal-body">
                <Form>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input1">
                          Topic
                        </label>
                        <Input id="input1" 
                          defaultValue={ this.state.topic} 
                          onChange={ e => this.setState({ topic: e.target.value }) } 
                          placeholder="Topic" 
                          type="text" />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input2">
                          English
                        </label>
                        <Input id="input2" 
                          defaultValue={ this.state.english} 
                          onChange={ e => this.setState({ english: e.target.value }) } 
                          placeholder="English" 
                          type="text" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input3">
                        Vietnamese
                        </label>
                        <Input id="input3" 
                          defaultValue={ this.state.vietnamese} 
                          onChange={ e => this.setState({ vietnamese: e.target.value }) } 
                          placeholder="Vietnamese" 
                          type="text" />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input5">
                        Pronunciation
                        </label>
                        <Input id="input5" 
                          defaultValue={ this.state.pronunciation} 
                          onChange={ e => this.setState({ pronunciation: e.target.value }) } 
                          placeholder="Pronunciation" 
                          type="text" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                      <Col lg="12">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input4">
                          Usage
                          </label>
                          <Input id="input4" 
                            defaultValue={ this.state.usage} 
                            onChange={ e => this.setState({ usage: e.target.value }) } 
                            placeholder="Usage" 
                            type="text" />
                        </FormGroup>
                      </Col>
                    </Row>
                </Form>
              </div>
              <div className="modal-footer">
                <Button 
                  disabled={ !(this.state.topic && this.state.english && this.state.vietnamese
                    && this.state.usage && this.state.pronunciation) }
                  color="primary" type="button" onClick={this.onSave}>
                  Save changes
                </Button>
                <Button
                  className="ml-auto"
                  color="link"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => this.toggleModal("defaultModal")}
                >
                  Close
                </Button>
              </div>
            </Modal>
        </Container>
      </>
    );
  }
}

export default Vocabulary;
